import { t } from 'i18next';

import { ErrorResponseErrorItemCodeSkyMapImage } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeSkyMapImage, string> => ({
  'skymap_image:skymap_image_not_found': t('skymapImage.skymapImageNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'SkyMapImage hittades inte.',
  }),
  'skymap_image:source_not_found': t('skymapImage.sourceNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Källan hittades inte.',
  }),
  'skymap_image:source_invalid_type': t('skymapImage.sourceInvalidType', {
    ns: 'apiErrorCodes',
    defaultValue: 'Källan har en ogiltig typ.',
  }),
});
